/* eslint-disable indent */
import dayjs from 'dayjs'

import { isBoolean } from '@local/utils'

import { MissionRewardSelectMethodType } from '@web/gql/graphql'

import { MissionCard, MissionCardProps } from '../MissionCard'
import styles from '../MissionCard.module.scss'
interface Props {
  missionCard: MissionCardProps
}

const ApplyDescription = ({ missionCard }: Props) => {
  const { reward, isRewarded } = missionCard
  const { selectMethod } = reward

  if (reward.type === 'profileBorder') {
    return <span className={styles.status}>프로필 아이템 지급 완료</span>
  }

  if (selectMethod === MissionRewardSelectMethodType.All) {
    return (
      <>
        완료
        <span className={styles.dot} />
        <span className={styles.status}>
          {isRewarded ? `${reward.name} 지급 완료 🎉` : `추후 ${reward.name} 지급 예정`}
        </span>
      </>
    )
  }

  if (
    [
      MissionRewardSelectMethodType.Pick,
      MissionRewardSelectMethodType.Random,
      MissionRewardSelectMethodType.RandomWithBenefit,
    ].includes(selectMethod)
  ) {
    if (!isBoolean(isRewarded)) return <>{reward.name} 응모 완료</>

    return (
      <>
        {isRewarded ? '완료' : '응모완료'}
        <span className={styles.dot} />
        <span className={styles.status}>{isRewarded ? `${reward.name} 당첨 🎉` : `아쉽지만 다음 기회에! 😣`}</span>
      </>
    )
  }

  return null
}

const Apply = ({ missionCard }: Props) => {
  const completedDateTime = MissionCard.getMissionCompleteDateTime(missionCard)?.toString()
  const rewardedDateTime = missionCard.rewardedDateTime

  const dateTime = rewardedDateTime ?? completedDateTime

  return (
    <div className={styles.date_area}>
      {dateTime && (
        <>
          <time aria-hidden="true">{dayjs(dateTime).locale('ko').format('M.D (dd)')}</time>
          <span className="place_blind">{dayjs(dateTime).locale('ko').format('M월 D일 dd요일')}</span>
        </>
      )}
      &nbsp;
      <ApplyDescription missionCard={missionCard} />
    </div>
  )
}

export default Apply
